import axios from '@/backend'

const state = {
  task_templates: []
}

const getters = {
  taskTemplatesCollection (state) {
    return state.task_templates.map(template => {
      return {label: template.text, value: template.id}
    })
  }
}

const mutations = {
  setTaskTemplates (state, taskTemplates) {
    state.task_templates = taskTemplates
  }
}
const actions = {
  loadTaskTemplates ({dispatch, commit}, payload) {
    axios.get('/task_templates', {params: {all_templates: true}})
      .then(function (response) {
        commit('setTaskTemplates', response.data)
      })
      .catch(e => { console.log(e.response) })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/task_templates.js